import React, { useState } from "react";
import { motion } from "framer-motion";
import Header from "../header/Header.jsx";
import Sidebar from "../sidebar/Sidebar.jsx";
import siteConfig from "../../../config.js";

const AppLayout = ({ children, title = siteConfig.name }) => {
  const [collapsed, setCollapsed] = useState(true);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <div>
      <div className="flex">
        <motion.div
          className="hidden lg:block"
          animate={{
            marginLeft: collapsed ? "0px" : "-250px",
            transition: { duration: 0.5 },
          }}
        >
          <Sidebar />
        </motion.div>

        <div
          className={`bg-bgColor lg:ml-[250px] ${collapsed ? "lg:w-[calc(100%-250px)]" : "lg:w-full"
            } w-full min-h-screen`}
        >
          <Header
            title={title}
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            isDrawerOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
          />
          <div className="p-2 md:p-4">{children}</div>
        </div>

        {isDrawerOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed top-0 left-0 bg-[#00000040] shadow-blue-gray-900/10 xl:hidden w-full z-10 h-full"
            onClick={() => setIsDrawerOpen(false)}
          >
            <motion.div
              initial={{ x: -250 }}
              animate={{ x: 0 }}
              exit={{ x: -250 }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
              className="bg-white w-[250px] h-full"
              onClick={(e) => e.stopPropagation()} // prevent backdrop click
            >
              <Sidebar setIsDrawerOpen={setIsDrawerOpen} />
            </motion.div>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default AppLayout;
